import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionService } from '../../app-user-session.service';
import { GenPatientServiceDetailService } from './gen-patient-service-detail.service';

@Component({
  selector: 'app-gen-patient-service-detail',
  templateUrl: './gen-patient-service-detail.component.html',
  styleUrls: ['./gen-patient-service-detail.component.css']
})
export class GenPatientServiceDetailComponent implements OnInit, OnDestroy {
  _medicalRepo: any = {};
  regPatServiceSerial: number;
  _parms:any ={};
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(private _userSessionService: UserSessionService,
    public translate: TranslateService,
    private _genpatService: GenPatientServiceDetailService
  ) { }
  ngOnInit() {
    let inputs  = this._userSessionService.getModalKey('GenPatientServiceDetailComponent')['inputs'];
    this.regPatServiceSerial = inputs.regPatServiceSerial;

    //-----
    this._parms.regPatServiceSerial = inputs.regPatServiceSerial ;
    this._parms.ccCallSerial = inputs.ccCallSerial ;
    
    //----- 
    this.getPatientData(this._parms);
    this._userSessionService.getModalKey$()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.inputs) {
          this.regPatServiceSerial = keys.inputs.regPatServiceSerial;
          this._parms = keys.inputs  ; 
        //ccCallSerial
        //resourceId: 951
        //scheduleTimeSerial: 1343
        //serial: 10014
          this.getPatientData( this._parms );
        }
      });
  }

  getPatientData(_parms: any) {
    this._medicalRepo = <any>{};
    this._genpatService.genPatientServiceDetailLoad(_parms).
      pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
        if (res && res.data.length > 0) {
          this._medicalRepo = res.data[0]
        }
      })
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
